import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_EVENTS } from "../../server/graphql/queries";
import PageContainer from "../../components/dashboard/PageContainer";
import Button from "../../components/Button";
import Loading from "../../components/Loading";

const Insights = () => {
  const [totalViews, setTotalViews] = useState(0);
  const [totalDps, setTotalDps] = useState(0);
  const { loading, error, data } = useQuery(GET_EVENTS);
  const events = data?.events || [];

  useEffect(() => {
    if (events) {
      setTotalViews(
        events.reduce(
          (previous, current) => previous + current.numberOfViews,
          0
        )
      );

      setTotalDps(
        events.reduce(
          (previous, current) => previous + current.numberOfDps,
          0
        )
      );
    }
  }, [events]);

  return (
    <PageContainer
      title="Dashboard"
      cta={
        <Button to="/dashboard/events/new" text="New Event" icon="new" />
      }
    >
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-y-10 gap-x-6">
          <div className="bg-white drop-shadow-lg rounded-md p-3 lg:p-5">
            <p className="text-sm text-zinc-500 mb-2">Total Events</p>
            <h1 className="text-4xl font-poppins">{events.length}</h1>
          </div>

          <div className="bg-white drop-shadow-lg rounded-md p-3 lg:p-5">
            <p className="text-sm text-zinc-500 mb-2">Total Views</p>
            <h1 className="text-4xl">{totalViews}</h1>
          </div>

          <div className="bg-white drop-shadow-lg rounded-md p-3 lg:p-5">
            <p className="text-sm text-zinc-500 mb-2">Total DPs Generated</p>
            <h1 className="text-4xl">{totalDps}</h1>
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default Insights;
